import { render, staticRenderFns } from "./DocsUploader.vue?vue&type=template&id=99c65286&scoped=true&"
import script from "./DocsUploader.vue?vue&type=script&lang=js&"
export * from "./DocsUploader.vue?vue&type=script&lang=js&"
import style0 from "./DocsUploader.vue?vue&type=style&index=0&id=99c65286&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c65286",
  null
  
)

export default component.exports